import type { PortfolioVideo } from '../types/portfolio';

const FALLBACK_CREATED_AT = '2026-07-21T00:00:00.000Z';
const SAFE_REPLACEMENT_CREATED_AT = '2026-07-28T00:00:00.000Z';

export const COMMENT_SECTION_PORTFOLIO_VIDEO_IDS = new Set([
  'PY3jpEnFYgU',
  'q-WNyhqwu9k',
  'HHkuYf5vv94',
  '2fB0jT1Jb-c',
  'TTJHfSbUadg',
  'N72FQftet5o',
]);

export const HIDDEN_PORTFOLIO_VIDEO_IDS = new Set([
  ...COMMENT_SECTION_PORTFOLIO_VIDEO_IDS,
  'QlbO0LmuKXI',
  'VHlZZPmE3IA',
  'sSM5eN1KupA',
  'AEe-og2l2R4',
  'n4JXO6EGh9c',
  'EqhGFf4zBUA',
  'qc9KL1zw10E',
  '4CGBwJKZyzc',
  'biz0T-cmTnE',
  '0OBgv3bkp3k',
  'QWOP7oZDm04',
  'XIuSOriQVn0',
  '2_AaA3xsS0g',
  '1afW4TyuHn4',
  'AmHc9NWOe3E',
  'hv48O6Pngtk',
  'tDTCJmTdXc8',
  'QmVzp5z0C6A',
]);

export const PORTFOLIO_VIDEO_REPLACEMENTS: PortfolioVideo[] = [
  {
    id: 'fallback-AmHc9NWOe3E',
    video_id: 'AmHc9NWOe3E',
    description: 'Editor',
    tag: 'Commentary',
    created_at: SAFE_REPLACEMENT_CREATED_AT,
  },
  {
    id: 'fallback-qUoiagLbLxY',
    video_id: 'qUoiagLbLxY',
    description: 'Editor',
    tag: 'Documentary',
    created_at: SAFE_REPLACEMENT_CREATED_AT,
  },
  {
    id: 'fallback-L-1v6vMz0xs',
    video_id: 'L-1v6vMz0xs',
    description: 'Editor',
    tag: 'Commentary',
    created_at: SAFE_REPLACEMENT_CREATED_AT,
  },
  {
    id: 'fallback-ja_NIgmBIAI',
    video_id: 'ja_NIgmBIAI',
    description: 'Editor',
    tag: 'Commentary',
    created_at: SAFE_REPLACEMENT_CREATED_AT,
  },
  {
    id: 'fallback-mxapaXrHr1Y',
    video_id: 'mxapaXrHr1Y',
    description: 'Editor',
    tag: 'Matt Walsh',
    created_at: FALLBACK_CREATED_AT,
  },
  {
    id: 'fallback-3aUtYVr62lw',
    video_id: '3aUtYVr62lw',
    description: 'Editor',
    tag: 'Ben Shapiro',
    created_at: FALLBACK_CREATED_AT,
  },
  {
    id: 'fallback-qWRxeOZz5L0',
    video_id: 'qWRxeOZz5L0',
    description: 'Editor',
    tag: 'Ben Shapiro',
    created_at: FALLBACK_CREATED_AT,
  },
  {
    id: 'fallback-mMMQYz_vJFw',
    video_id: 'mMMQYz_vJFw',
    description: 'Editor',
    tag: 'Jordan B Peterson',
    created_at: FALLBACK_CREATED_AT,
  },
];

export const replaceCommentSectionPortfolioVideos = (
  videos: PortfolioVideo[]
): PortfolioVideo[] => {
  const nonCommentVideos = videos.filter(
    video => !HIDDEN_PORTFOLIO_VIDEO_IDS.has(video.video_id)
  );
  const existingVideoIds = new Set(nonCommentVideos.map(video => video.video_id));
  const missingReplacements = PORTFOLIO_VIDEO_REPLACEMENTS.filter(
    replacement =>
      !existingVideoIds.has(replacement.video_id) &&
      !HIDDEN_PORTFOLIO_VIDEO_IDS.has(replacement.video_id)
  );

  return [...missingReplacements, ...nonCommentVideos].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
};
